'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('calendar-edit', {
      url: '/calendar/event/edit/:id',
      template: '<calendar-edit></calendar-edit>',
        authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/calendar/edit/calendar-edit.routes.js